// Data
import topics from "~/data/topics.json";

// Deps
import { selectStyles } from "~/styleguide/forms";
import { createComponent } from "react-fela";

// Components
import MultiSelect from "~/components/shared/form/multi-select";

// Grab topics with more than one published resource
const options = topics
    .map(topic => {
        return { value: topic.id, label: topic.name, count: topic.count };
    })
    .filter(({ count }) => count && count > 0);

export default function TopicFilter({ handleTopicChange, selected }) {
    // Can't filter by topics if there are none
    if (!topics || !topics.length) return null;

    return (
        <Container>
            <p style={{ fontSize: "14px", marginBottom: "12px" }}>
                Filter by topic
            </p>

            <MultiSelect
                options={options}
                onChange={handleTopicChange}
                selected={selected}
                type="Topic"
            />
        </Container>
    );
}

const Container = createComponent(() => ({
    ...selectStyles
}));
